import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RecuAgencePaymentComponent } from "./recu-agence-payment.component";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { RouterModule } from "@angular/router";
import { TranslocoModule } from "@ngneat/transloco";



@NgModule({
  declarations: [
    RecuAgencePaymentComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    TranslocoModule,
  ],
  exports:[
    RecuAgencePaymentComponent,
  ],
})
export class RecuAgencePaymentModule { }
